<template>
  <div class="mt-2 py-2 border-t border-b text-[18px]">
    <div v-if="needBeConfirmModel"
         class="flex items-center text-osn-blue-00">
      <el-icon class="mr-2">
        <Check/>
      </el-icon>
      一個工作日確認(不含假日，email 簡訊通知)
      <img @click="cancelHintVisible=true"
           class="ml-2 cursor-pointer"
           src="@/assets/image/icon/space/ic_arrow_circle.svg"
           alt="">
    </div>
    <div v-else
         class="flex items-center text-osn-blue-00">
      <el-icon class="mr-2">
        <Trophy/>
      </el-icon>
      立即預訂不需確認
    </div>

    <div v-if="hintModel"
         class="mt-2 flex">
      <span class="mr-5 flex items-center"><el-icon class="mr-2"><Message/></el-icon>現場請出示訂單Email</span>
    </div>
    <div v-if="hintModel"
         class="mt-2 flex"
         @click="copyData(spaceIdModel)">
      <span class="mr-5 flex items-center">
        <el-icon class="mr-2"><Warning/></el-icon>
        空間ID：{{ spaceIdModel }}
          <img class="ml-2 cursor-pointer"
               src="@/assets/image/icon/order/content_copy.svg"
               alt="">
      </span>
    </div>
  </div>


  <!--彈窗-->
  <el-dialog
      v-model="cancelHintVisible"
      width="90%"
      center
      align-center>
    <div class="bg-white p-[16px] text-[18px]">
      若廠商無法收單，【全額款項】將退回至會員的原刷卡銀行，
      處理時間約為 7-14 個工作天（實際時間視發卡銀行而定）。
      如遇信用卡結帳日，退款將在下期帳單中扣除，
      詳情請聯繫發卡銀行確認進度。
    </div>

  </el-dialog>
</template>

<script setup
        lang="ts">
import {Trophy, Check, Message, Warning} from '@element-plus/icons-vue'
import {ElMessage} from "element-plus";
import {computed} from "vue";
import {useSettingStore} from "~/stores/setting";



const needBeConfirmModel = defineModel('needBeConfirm', {type: Boolean, default: true})
const hintModel = defineModel('hintModel', {type: Boolean, default: true})
const spaceIdModel = defineModel('spaceId', {type: String, default: ''})
const {t} = useI18n();
const settingStore = useSettingStore()
const isMobile = computed(() => settingStore.isMobile);

const cancelHintVisible = ref(false)

const showMSG = (status, text) => {
  ElMessage({
    message: text,
    grouping: true,
    type: status,
    duration: 1500,
    offset: isMobile.value ? 65 : 16,
    showClose: false
  })
}
const copyData = (string) => {

  navigator.clipboard.writeText(string)
      .then(() => {
        showMSG('success', t('common.copy_successfully'))
      })
      .catch(err => {
        console.log(err);
        showMSG('error', t('common.copy_failed'))
      });
}
</script>

<style scoped
       lang="scss">

</style>
